import { render, staticRenderFns } from "./UserDeleteReport.vue?vue&type=template&id=4785cb57&scoped=true"
import script from "./UserDeleteReport.vue?vue&type=script&lang=js"
export * from "./UserDeleteReport.vue?vue&type=script&lang=js"
import style0 from "./UserDeleteReport.vue?vue&type=style&index=0&id=4785cb57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785cb57",
  null
  
)

export default component.exports